import React, { useState } from "react";

// <input type="password"> with an eye button that toggles the value between hidden and plain text.
// Accepts any native input props (value, onChange, onFocus, style, ...).
const PasswordInput = ({ style, ...props }) => {
    const [visible, setVisible] = useState(false);
    return (
        <div style={{ position: "relative" }}>
            <input {...props} type={visible ? "text" : "password"} style={{ ...style, paddingRight: 40 }} />
            <button
                type="button"
                onClick={() => setVisible(v => !v)}
                title={visible ? "Hide password" : "Show password"}
                aria-label={visible ? "Hide password" : "Show password"}
                tabIndex={-1}
                style={{
                    position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)",
                    width: 28, height: 28, padding: 0, border: 0, background: "transparent",
                    color: "#94a3b8", fontSize: 15, lineHeight: 1, cursor: "pointer"
                }}
            >
                <i className={`bi ${visible ? "bi-eye-slash" : "bi-eye"}`} aria-hidden="true"></i>
            </button>
        </div>
    );
};

export default PasswordInput;
